<div mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle class="draggable-container">
  <mat-toolbar>
    <ng-content></ng-content>
  </mat-toolbar>
</div>